// extracted by mini-css-extract-plugin
export default {"card":"styles_card__yEJLy","title":"styles_title__N3-yP"};